import styled, { css } from 'styled-components';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { maxWidthCustom } from '@components/ui/JourneyListProposals/ActionConfirmHiring/ActionConfirmHiringStyles';

export const WrapperStyledFuelGridContainer = styled.div<{
  hasBorder?: boolean;
}>`
  ${({ theme, hasBorder }) => css`
    .grid-container.sc-fuel-grid-container-h {
      margin: ${theme.spacing.km0};
      align-items: center;
      padding: ${theme.spacing.km4} 0 ${theme.spacing.km4} 0;
    }
    :hover {
      background-color: #f9f9f9;
      cursor: pointer;
    }

    border-bottom: ${theme.border.style.solid} ${theme.border.width.thinner}
      ${theme.color.border.neutral.default};

    ${!hasBorder &&
    css`
      border-bottom: none;
    `}

    fuel-tooltip {
      display: inline-block;
    }
  `}
`;

export const WrapperColumnAction = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: ${theme.spacing.km2};
    text-align: center;

    .grid-container.sc-fuel-grid-container-h {
      column-gap: ${theme.spacing.km5};
      justify-items: end;
      gap: ${theme.spacing.km5};
      padding: ${theme.spacing.km0};
    }
  `}
`;

export const WrapperRow = styled.div`
  .grid-container.sc-fuel-grid-container-h {
    column-gap: 0;
  }
`;

export const WrapperMarker = styled.div<{ isMarker: boolean }>`
  ${({ theme, isMarker }) => css`
    position: relative;
    padding-left: ${!isMarker ? theme.spacing.km0 : theme.spacing.km5};
    transition: padding-left 0.3s;

    ::before {
      content: '';
      width: ${theme.spacing.km0};
      height: 100%;
      border-radius: 0px ${theme.border.radius.medium}
        ${theme.border.radius.medium} 0px;
      background: ${theme.color.background.brand.default};
      display: block;
      position: absolute;
      left: 0;
      opacity: 0;
      overflow: hidden;
      transition: width 0.3s, opacity 0.3s;
    }

    ${isMarker &&
    css`
      ::before {
        width: ${theme.spacing.km1};
        opacity: 1;
      }
    `}
  `}
`;

export const WrapperButtonEvaluate = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing.km2};
    font-size: inherit;
    font-weight: ${theme.font.weight.bold};
    align-items: center;
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing.km2};
    @media screen and (min-width: ${dsTokens.breakpoint.lg
        .minWidth}) and (max-width: ${maxWidthCustom}) {
      fuel-button::part(button) {
        min-width: auto;
        text-wrap: wrap;
        padding: 0px ${theme.padding.km3};
      }
    }
  `}
`;
